import { render } from "./TextModeChanger.vue?vue&type=template&id=6934d903&scoped=true"
import script from "./TextModeChanger.vue?vue&type=script&lang=js"
export * from "./TextModeChanger.vue?vue&type=script&lang=js"

import "./TextModeChanger.vue?vue&type=style&index=0&id=6934d903&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6934d903"]])

export default __exports__